// https://github.com/mbj36/vue-burger-menu
import Vue from 'vue'
import { Slide as VueBurgerMenu } from 'vue-burger-menu'

Vue.component('VueBurgerMenu', VueBurgerMenu)
